module.exports = __webpack_public_path__ + "img/wlcbg_img.fb4befdc.png";